import axios from "axios";
import firebase from "./firebase";

export const fetchReferralLetter = async (letterId, source) => {
  const userIdToken = await firebase.currentUser().getIdToken();
  return axios.get(`${process.env.REACT_APP_REFERRAL_LETTERS}/${letterId}?source=${source}`, {
    headers: { Authorization: `Bearer ${userIdToken}` },
    responseType: "blob",
  });
};

export const downloadReferralLetter = (blob, name) => {
  const url = window.URL.createObjectURL(new Blob(blob));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", name);
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
};
